module.exports = __webpack_public_path__ + "img/historyImg2.c6bebe50.png";